/*
 * Copyright 2024, Corning Optical Communications
 * All Rights Reserved.
 */

import { AppState } from "../../";

export const dasInventoryEquipmentTypeSelector = (state: AppState) => state.dasInventoryFilter?.selectedEquipmentType || "";
export const dasInventoryStatusSelector = (state: AppState) => state.dasInventoryFilter?.selectedStatus || "";
export const dasInventoryBandSelector = (state: AppState) => state.dasInventoryFilter?.selectedBand || "";
export const dasInventorySearchTextSelector = (state: AppState) => state.dasInventoryFilter?.searchText || "";
export const dasInventoryFiltersSelector = (state: AppState) => state.dasInventoryFilter || {};
